export default "__VITE_ASSET__CXFp6rQc__"